<style scoped>
table {
  @apply w-full mt-5 table-auto border-collapse text-[0.9em] shadow-md;
}

table thead tr {
  @apply bg-[rgb(224,224,224)] text-black text-left;
}

table th,
table td {
  @apply py-2 px-3;
}

table tbody tr {
  border-bottom: 1px solid #dddddd;
}

table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

table tbody tr:last-of-type {
  border-bottom: 2px solid #dddddd;
}

tr.row-summary > td {
  border-top: 2px solid #dddddd;
  font-size: 1.1em !important;
  font-weight: bold;
  background-color: #fff;
}

.font-mono {
  font-family: monospace !important;
}

.cursor-pointer {
  cursor: pointer !important;
}
</style>
<template>
  <div>
    <a @click="goBack" class="cursor-pointer">Gå tilbake</a>

    <InfoCard class="mt-4"
      >På denne siden så finner du detaljer om faktura {{ landlordProfileInvoice.invoiceNumber }}</InfoCard
    >

    <BlockContainer class="mt-4 p-5">
      <h5>Faktura | {{ landlordProfileInvoice.invoiceNumber }}</h5>
      <table>
        <thead>
          <tr>
            <th>Fakturatekst</th>
            <th class="text-right">Periode</th>
            <th class="font-mono text-right">Eks. mva.</th>
            <th class="font-mono text-right">Mva</th>
            <th class="font-mono text-right"></th>
            <th class="font-mono text-right">Ink. mva</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in landlordProfileInvoice.rows" :key="i">
            <td>{{ row.title }}</td>
            <td class="text-right"><hl-Date :date="row.period" format="MMM YYYY" /></td>
            <td class="font-mono text-right"><hl-Currency :amount="priceWithoutVat(row)"></hl-Currency></td>
            <td class="font-mono text-right"><hl-Currency :amount="vatAmountOfPrice(row)"></hl-Currency></td>
            <td class="font-mono text-right">
              <span v-if="row.quantity > 1">x {{ row.quantity }}</span>
            </td>
            <td class="font-mono text-right">
              <hl-Currency :amount="row.price * row.quantity"></hl-Currency>
            </td>
          </tr>
          <tr class="row-summary">
            <td><strong>Totalt</strong></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="font-mono text-right">
              <strong><hl-Currency :amount="landlordProfileInvoice.totalAmount"></hl-Currency></strong>
            </td>
          </tr>
        </tbody>
      </table>
    </BlockContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BlockContainer from '@/components/BlockContainer.vue';
import InfoCard from '@/components/InfoCard.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';

export default {
  components: {
    BlockContainer,
    InfoCard,
    'hl-Date': Date,
    'hl-Currency': Currency,
  },

  data() {
    return {
      landlordProfileInvoice: {
        rows: [],
      },
    };
  },

  computed: {
    ...mapGetters(['getLandlordInvoice']),
  },

  methods: {
    ...mapActions(['loadLandlordProfileInvoice']),
    vatAmountOfPrice(row) {
      return row.vat ? (row.price / 1.25) * 0.25 : 0;
    },
    priceWithoutVat(row) {
      return row.price - this.vatAmountOfPrice(row);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  async mounted() {
    const invoiceId = this.$route.params.invoiceId;

    if (invoiceId) {
      try {
        const res = await this.loadLandlordProfileInvoice(this.$route.params.invoiceId);
        this.landlordProfileInvoice = res;
      } catch (error) {
        this.$toast('Kunne ikke laste faktura.', 'error');
      }
    }
  },
};
</script>
